/**
 * ч.948 (рішення власника): посилання «створити ↗» біля полів «Контрагент» /
 * «Договір» у документах — відкриває ПОПАП створення просто на сторінці
 * документа (не йдемо у нову вкладку). Вигляд — еталонний, як на рахунку
 * покупцю; неактивний стан сірий з підказкою.
 */
export default function QuickCreateLink({ onClick, disabled, title }: {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
}) {
  return (
    <a
      role="button"
      tabIndex={disabled ? -1 : 0}
      title={title}
      onClick={() => { if (!disabled) onClick(); }}
      onKeyDown={(e) => { if (e.key === 'Enter' && !disabled) onClick(); }}
      style={{
        fontSize: '0.82rem', fontWeight: 'normal', marginLeft: 6,
        cursor: disabled ? 'default' : 'pointer',
        color: disabled ? 'var(--muted)' : 'var(--primary)',
      }}
    >
      створити ↗
    </a>
  );
}
